<template>
    <div class="invoice-design-page">
        <div v-if="loading && !designLoaded" class="invoice-design-initial-loading" v-loading="true"></div>
        <el-alert v-else-if="loadError !== ''" :title="loadError" type="error" :closable="false" show-icon></el-alert>
        <div v-else-if="designLoaded" class="invoice-design-layout">
        <div class="leftScrollbar invoice-design-sidebar">
            <div class="invoice-design-save-bar">
                <el-button @click.native.prevent="saveDesign" type="success"
                           :disabled="!designLoaded || loading || buttonDisabledStatus || pageHaveChange !== 1">{{$t('common.save')}}</el-button>
            </div>
            <el-scrollbar class="invoice-design-scroll">
            <el-collapse v-model="activeNames" accordion @change="handleChange" style="border-width: 2px;height: 100%;border-top-style: none">

                <el-collapse-item :title="$t('invoiceDesign.template')" name="1">

                    <div style="display: flex;flex-wrap:wrap;align-content: space-between;">

                        <div style="flex-basis: 100%;display: flex; justify-content: space-between;margin-left: 10%;margin-right: 10%;margin-bottom: 20px">
                            <img v-on:click="selectPdfStyle('Classic',0)" role="button" tabindex="0" :aria-pressed="String(choosePdfStyle === 'Classic')"
                                 @keydown.enter="selectPdfStyle('Classic',0)" @keydown.space.prevent="selectPdfStyle('Classic',0)"
                                 v-bind:style="{'border-style':'dashed','border-color':predefinePdfStyleList[0][1],'border-width':'1px','cursor':'pointer'}"
                                 width="40%" src="@/static/pdf_icon/classic.png" alt="Classic">

                            <img v-on:click="selectPdfStyle('Impact',1)" role="button" tabindex="0" :aria-pressed="String(choosePdfStyle === 'Impact')"
                                 @keydown.enter="selectPdfStyle('Impact',1)" @keydown.space.prevent="selectPdfStyle('Impact',1)"
                                 v-bind:style="{'border-style':'dashed','border-color':predefinePdfStyleList[1][1],'border-width':'1px','cursor':'pointer'}"
                                 width="40%" src="@/static/pdf_icon/Impact.svg" alt="Impact">
                        </div>
                        <div style="flex-basis: 100%;display: flex;justify-content: space-between;margin-left: 10%;margin-right: 10%;margin-bottom: 20px">
                            <img v-on:click="selectPdfStyle('Minimal',2)" role="button" tabindex="0" :aria-pressed="String(choosePdfStyle === 'Minimal')"
                                 @keydown.enter="selectPdfStyle('Minimal',2)" @keydown.space.prevent="selectPdfStyle('Minimal',2)"
                                 v-bind:style="{'border-style':'dashed','border-color':predefinePdfStyleList[2][1],'border-width':'1px','cursor':'pointer'}"
                                 width="40%" src="@/static/pdf_icon/Minimal.svg" alt="Minimal">

                            <img v-on:click="selectPdfStyle('Elegance',3)" role="button" tabindex="0" :aria-pressed="String(choosePdfStyle === 'Elegance')"
                                 @keydown.enter="selectPdfStyle('Elegance',3)" @keydown.space.prevent="selectPdfStyle('Elegance',3)"
                                 v-bind:style="{'border-style':'dashed','border-color':predefinePdfStyleList[3][1],'border-width':'1px','cursor':'pointer'}"
                                 width="40%" src="@/static/pdf_icon/Elegance.svg" alt="Elegance">
                        </div>
                        <div style="flex-basis: 100%;display: flex;justify-content: space-between;margin-left: 10%;margin-right: 10%;margin-bottom: 20px">
                            <img v-on:click="selectPdfStyle('Modern',4)" role="button" tabindex="0" :aria-pressed="String(choosePdfStyle === 'Modern')"
                                 @keydown.enter="selectPdfStyle('Modern',4)" @keydown.space.prevent="selectPdfStyle('Modern',4)"
                                 v-bind:style="{'border-style':'dashed','border-color':predefinePdfStyleList[4][1],'border-width':'1px','cursor':'pointer'}"
                                 width="40%" src="@/static/pdf_icon/Modern.svg" alt="Modern">

                            <img v-on:click="selectPdfStyle('Creative',5)" role="button" tabindex="0" :aria-pressed="String(choosePdfStyle === 'Creative')"
                                 @keydown.enter="selectPdfStyle('Creative',5)" @keydown.space.prevent="selectPdfStyle('Creative',5)"
                                 v-bind:style="{'border-style':'dashed','border-color':predefinePdfStyleList[5][1],'border-width':'1px','cursor':'pointer'}"
                                 width="40%" src="@/static/pdf_icon/Creative.svg" alt="Creative">
                        </div>
                    </div>

                </el-collapse-item>

                <el-collapse-item :title="$t('invoiceDesign.color')" name="2">
                    <div class="collection" style="display: flex;flex-wrap:wrap;align-items:center;margin-left: 6%;margin-top: 20px">
                        <el-card shadow="hover"
                                 role="button" tabindex="0" :aria-label="color" :aria-pressed="String(chooseColor === color)"
                                 v-for="color in predefineColors"
                                 :key="color"
                                 @click.native="selected(color)"
                                 @keydown.native.enter="selected(color)" @keydown.native.space.prevent="selected(color)"
                                 v-bind:style="{'background-color':color,'width':'40px','height':'40px','margin-right':'4%','margin-bottom':'35px','cursor':'pointer'}">
                            <label v-if="chooseColor == color"><i class="el-icon-circle-check" style="color: white;font-size: 18px;"></i></label>
                        </el-card>
                    </div>
                </el-collapse-item>

                <el-collapse-item :title="$t('invoiceDesign.labels')" name="3">

                    <el-form class="aaaa" label-position="top" label-width="80px">
                        <el-form-item :label="$t('invoiceDesign.labelInvoice')">
                            <el-input v-model="label.invoiceLabel"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.labelEstimate')">
                            <el-input v-model="label.estimateLabel"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.labelPurchaseOrder')">
                            <el-input v-model="label.purchaseOrderLabel"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.labelCreditMemo')">
                            <el-input v-model="label.creditMemoLabel"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.labelReceipt')">
                            <el-input v-model="label.receiptLabel"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.labelTermsFormat')">
                            <el-input v-model="label.termsFormatLabel"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.labelBillTo')">
                            <el-input v-model="label.billToLabel"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.labelFor')">
                            <el-input v-model="label.forLabel"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.labelDate')">
                            <el-input v-model="label.dateLabel"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.labelInvoiceNo')">
                            <el-input v-model="label.invoiceNoLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelEstimateNo')">
                            <el-input v-model="label.estimateNoLabel"></el-input>
                        </el-form-item>


                        <el-form-item :label="$t('invoiceDesign.labelPoNo')">
                            <el-input v-model="label.purchaseOrderNoLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelCreditMemoNo')">
                            <el-input v-model="label.creditMemoNoLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelDueDate')">
                            <el-input v-model="label.dueDateLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelTerms')">
                            <el-input v-model="label.termsLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelAmount')">
                            <el-input v-model="label.amountLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelCode')">
                            <el-input v-model="label.codeLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelDescription')">
                            <el-input v-model="label.descriptionLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelQuantity')">
                            <el-input v-model="label.quantityLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelRate')">
                            <el-input v-model="label.rateLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelTax')">
                            <el-input v-model="label.taxLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelSubtotal')">
                            <el-input v-model="label.subtotalLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelBalanceDue')">
                            <el-input v-model="label.balanceDueLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelDiscount')">
                            <el-input v-model="label.discountLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelNonTaxableItem')">
                            <el-input v-model="label.nonTaxableItemLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelPaid')">
                            <el-input v-model="label.paidLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelShipping')">
                            <el-input v-model="label.shippingLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelTotal')">
                            <el-input v-model="label.totalLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelIncludes')">
                            <el-input v-model="label.includesLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelTotalAmountPaid')">
                            <el-input v-model="label.totalAmountPaidLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelShipDate')">
                            <el-input v-model="label.shipDateLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelShipTo')">
                            <el-input v-model="label.shipToLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelShipVia')">
                            <el-input v-model="label.shipViaLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelTrackingNo')">
                            <el-input v-model="label.trackingNoLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelFob')">
                            <el-input v-model="label.fobLabel"></el-input>
                        </el-form-item>

                        <!--<el-form-item label="F.O.B">
                            <el-input v-model="label.paymentInstructionsLabel"></el-input>
                        </el-form-item>-->

                    </el-form>

                </el-collapse-item>
                <el-collapse-item :title="$t('invoiceDesign.prefix')" name="4">
                    <el-form label-position="top" label-width="80px" class="aaaa">
                        <el-form-item :label="$t('invoiceDesign.prefixInvoice')">
                            <el-input v-model="companyInfo.invoiceNumbering"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.prefixEstimate')">
                            <el-input v-model="companyInfo.estimateNumbering"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.prefixPurchaseOrder')">
                            <el-input v-model="companyInfo.purchaseOrderNumbering"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.prefixCreditMemo')">
                            <el-input v-model="companyInfo.creditMemoNumbering"></el-input>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item :title="$t('invoiceDesign.nextNumber')" name="6">
                    <el-form label-position="top" label-width="80px" class="aaaa">
                        <div class="next-number-title">{{$t('invoiceDesign.numberingBeginsAt')}}</div>
                        <el-form-item :label="$t('invoiceDesign.nextNumberInvoice')">
                            <el-input inputmode="numeric" v-model="companyInfo.nextNewInvoiceNumber"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.nextNumberEstimate')">
                            <el-input inputmode="numeric" v-model="companyInfo.nextNewEstimateNumber"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.nextNumberPurchaseOrder')">
                            <el-input inputmode="numeric" v-model="companyInfo.nextNewPurchaseOrderNumber"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.nextNumberCreditMemo')">
                            <el-input inputmode="numeric" v-model="companyInfo.nextNewCreditMemoNumber"></el-input>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item :title="$t('invoiceDesign.options')" name="5">
                    <el-form class="invoice-design-options-form" label-position="left" label-width="230px" style="margin-left: 6%">
                        <el-form-item :label="$t('invoiceDesign.optionTerms')" prop="delivery">
                            <el-switch v-model="label.isShowPaymentTerms" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionDueDate')" prop="delivery">
                            <el-switch v-model="label.isShowDueDate" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionShippingAddress')" prop="delivery">
                            <el-switch v-model="label.isShowShippingField" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionProductCode')" prop="delivery">
                            <el-switch v-model="label.isShowProduceCode" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionQuantityAndRate')" prop="delivery">
                            <el-switch v-model="label.isShowQuantityAndRate" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionUnit')" prop="delivery">
                            <el-switch v-model="companyInfo.isShowItemUnit" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionTax')" prop="delivery">
                            <el-switch v-model="label.isShowTaxColumn" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionAmount')" prop="delivery">
                            <el-switch v-model="label.isShowAmount" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionNonTaxableItemStar')" prop="delivery">
                            <el-switch v-model="companyInfo.isShowNonTaxableItemStar" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionDiscount')" prop="delivery">
                            <el-switch v-model="companyInfo.isShowItemDiscount" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionTaxBreakdown')" prop="delivery">
                            <el-switch v-model="label.isShowTaxBreakdown" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionPaymentHistory')" prop="delivery">
                            <el-switch v-model="label.isShowPaymentDetail" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionStamp')" prop="delivery">
                            <el-switch v-model="companyInfo.isShowStamp" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionPageNumber')" prop="delivery">
                            <el-switch v-model="companyInfo.isShowPDFPageNumber" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
            </el-scrollbar>
        </div>
        <div class="invoice-design-preview-scroll">

            <div class="rightScrollbar">

                <div v-if="choosePdfStyle==='Classic'" style="display: flex;justify-content:space-between;">
                    <div style="margin-left: 3%">
                        <img :style="{'padding-top': '20px', width: logoPreviewWidth + 'px'}" :src="logoPreviewSrc" alt="">

                        <div v-bind:style="{ 'color': chooseColor,'margin-top': '20px','font-size': '40px','font-weight':'bold'}">{{previewLabel.invoiceLabel}}</div>
                        <div v-if="previewCompanyInfo.hideBusinessName === 0"
                             :style="{'font-weight': 'bold', 'font-size': businessNamePreviewFontSize + 'px'}"><span>{{previewCompanyInfo.companyName}}</span></div>
                    </div>

                    <div style="text-align: right;margin-right: 3%;padding-top: 20px;align-self:flex-end">
                        <div>{{previewCompanyInfo.contactName}}</div>
                        <div>{{previewCompanyInfo.phone}}</div>
                        <div>{{previewCompanyInfo.companyEmail}}</div>
                        <div>{{previewCompanyInfo.businessNumber}}</div>
                        <div>{{previewLabel.taxRegNValue}}</div>
                        <div v-html="previewCustomFields.other"></div>
                        <div style="margin-top: 20px">{{previewCompanyInfo.addressOne}}</div>
                        <div>{{previewCompanyInfo.addressTwo}}</div>
                        <div>{{previewCompanyInfo.addressThree}}</div>
                    </div>
                </div>

                <div v-else-if="choosePdfStyle==='Impact' || choosePdfStyle==='Minimal'|| choosePdfStyle==='Modern'" v-bind:style="{'margin-bottom':'30px','background': modernBackgroundColor,'color': titlePartColor}">
                    <div style="margin-left: 3%">
                        <img :style="{'padding-top': '20px', width: logoPreviewWidth + 'px'}" :src="logoPreviewSrc" alt="">
                        <div v-if="previewCompanyInfo.hideBusinessName === 0"
                             :style="{'margin-top': '20px', 'font-weight': 'bold', 'font-size': businessNamePreviewFontSize + 'px'}"><span>{{previewCompanyInfo.companyName}}</span></div>
                    </div>

                    <div style="text-align: right;margin-right: 3%;padding-top: 20px;display: flex;justify-content:space-between;align-items:flex-start ">
                        <div style="text-align: left;margin-left: 3%">
                            <div>{{previewCompanyInfo.contactName}}</div>
                            <div>{{previewCompanyInfo.phone}}</div>
                            <div>{{previewCompanyInfo.companyEmail}}</div>
                            <div>{{previewCompanyInfo.businessNumber}}</div>
                            <div v-html="previewCustomFields.other"></div>
                        </div>
                        <div style="text-align: left">
                            <div>{{previewLabel.taxRegNValue}}</div>
                            <div>{{previewCompanyInfo.addressOne}}</div>
                            <div>{{previewCompanyInfo.addressTwo}}</div>
                            <div>{{previewCompanyInfo.addressThree}}</div>
                        </div>
                        <div v-bind:style="{ 'color': invoiceLabelColor,'font-size': '40px','font-weight':'bold','align-self':'flex-end'}">{{previewLabel.invoiceLabel}}</div>
                    </div>
                </div>

                <div v-if="choosePdfStyle==='Elegance'">
                    <div style="text-align: center">
                        <img :style="{'padding-top': '20px', width: logoPreviewWidth + 'px'}" :src="logoPreviewSrc" alt="">
                        <div v-if="previewCompanyInfo.hideBusinessName === 0"
                             :style="{'font-weight': 'bold', 'font-size': businessNamePreviewFontSize + 'px'}"><span>{{previewCompanyInfo.companyName}}</span></div>

                    </div>

                    <div style="display: flex;justify-content:space-between;margin-left: 3%;margin-right: 3%;margin-bottom: 20px;margin-top: 5px">
                        <div>
                            <div>{{previewCompanyInfo.contactName}}</div>
                            <div>{{previewCompanyInfo.phone}}</div>
                            <div>{{previewCompanyInfo.companyEmail}}</div>
                            <div>{{previewCompanyInfo.businessNumber}}</div>
                            <div>{{previewLabel.taxRegNValue}}</div>
                            <div v-html="previewCustomFields.other"></div>
                        </div>
                        <div>
                            <div>{{previewCompanyInfo.addressOne}}</div>
                            <div>{{previewCompanyInfo.addressTwo}}</div>
                            <div>{{previewCompanyInfo.addressThree}}</div>
                        </div>
                        <div v-bind:style="{ 'color': chooseColor,'margin-top': '20px','font-size': '40px','font-weight':'bold','align-self':'flex-end'}">{{previewLabel.invoiceLabel}}</div>
                    </div>

                </div>


                <div v-else-if="choosePdfStyle==='Creative'" v-bind:style="{'margin-bottom':'30px','background': modernBackgroundColor}">
                    <div v-bind:style="{'padding-left':'3%', 'background': creativeInvoiceLabelBackgroundColor,'color': 'white','font-size': '90px','line-height': '75%','font-weight':'bold'}">{{previewLabel.invoiceLabel}}</div>
                    <div v-if="previewCompanyInfo.hideBusinessName === 0"
                         :style="{'margin-left': '3%', 'margin-top': '20px', 'font-weight': 'bold', 'font-size': businessNamePreviewFontSize + 'px'}"><span>{{previewCompanyInfo.companyName}}</span></div>

                    <div style="text-align: right;margin-right: 3%;padding-top: 20px;display: flex;justify-content:space-between;align-items:flex-start ">
                        <div style="text-align: left;margin-left: 3%">
                            <div>{{previewCompanyInfo.contactName}}</div>
                            <div>{{previewCompanyInfo.phone}}</div>
                            <div>{{previewCompanyInfo.companyEmail}}</div>
                            <div>{{previewCompanyInfo.businessNumber}}</div>
                            <div v-html="previewCustomFields.other"></div>
                        </div>
                        <div style="text-align: left">
                            <div>{{previewLabel.taxRegNValue}}</div>
                            <div>{{previewCompanyInfo.addressOne}}</div>
                            <div>{{previewCompanyInfo.addressTwo}}</div>
                            <div>{{previewCompanyInfo.addressThree}}</div>
                        </div>
                        <img :style="{width: logoPreviewWidth + 'px'}" :src="logoPreviewSrc" alt="">
                    </div>
                </div>


                <el-divider v-if="choosePdfStyle==='Classic' || choosePdfStyle==='Impact'"></el-divider>

                <div style="display: flex;margin-left: 3%;margin-right: 3%">
                    <div style="width: 10%;font-weight:bold;">{{previewLabel.billToLabel}}</div>
                    <div style="width: 40%">
                        <div>{{$t('invoiceDesign.previewName')}}</div>
                        <div>{{$t('invoiceDesign.previewAddress')}}</div>
                        <div>{{$t('invoiceDesign.previewCity')}}</div>
                        <div>{{$t('invoiceDesign.previewZip')}}</div>
                    </div>
                    <div style="width: 25%;text-align:right">
                        <div>{{previewLabel.invoiceNoLabel}}</div>
                        <div>{{previewLabel.dateLabel}}</div>
                        <div v-if="previewLabel.isShowPaymentTerms===1">{{previewLabel.termsLabel}}</div>
                        <div v-if="previewLabel.isShowDueDate===1">{{previewLabel.dueDateLabel}}</div>
                        <div v-html="previewCustomFields.jobLabels"></div>
                    </div>
                    <div style="width: 25%;text-align:right;">
                        <div>{{previewCompanyInfo.invoiceNumbering}}99</div>
                        <div>{{$t('invoiceDesign.previewDate')}}</div>
                        <div v-if="previewLabel.isShowPaymentTerms===1">{{previewLabel.termsFormatLabel}} {{previewLabel.term}}</div>
                        <div v-if="previewLabel.isShowDueDate===1">{{$t('classicPDF.previewDueDate')}}</div>
                        <div v-html="previewCustomFields.jobValues"></div>
                    </div>
                </div>

                <div>
                    <div style="display: flex;margin-left: 3%; margin-right:3%;margin-top: 30px">
                        <div style="width: 10%;font-weight:bold;">{{previewLabel.shipToLabel}}</div>
                        <div style="width: 40%">
                            <div>{{$t('invoiceDesign.previewShipName')}}</div>
                            <div>{{$t('invoiceDesign.previewAddress')}}</div>
                            <div>{{$t('invoiceDesign.previewCity')}}</div>
                            <div>{{$t('invoiceDesign.previewZip')}}</div>
                        </div>
                        <div style="width: 25%;text-align:right">
                            <div>{{previewLabel.shipDateLabel}}</div>
                            <div>{{previewLabel.trackingNoLabel}}</div>
                            <div>{{previewLabel.shipViaLabel}}</div>
                            <div>{{previewLabel.fobLabel}}</div>
                        </div>
                        <div style="width: 25%;text-align:right;">
                            <div>{{$t('invoiceDesign.previewShipDate')}}</div>
                            <div>12345</div>
                            <div>{{$t('invoiceDesign.previewShipVia')}}</div>
                            <div>123</div>
                        </div>
                    </div>
                </div>

                <el-table
                        :data="tableData"
                        :header-cell-style="{'font-size':'13px', 'background-color': itemTableAndBalanceDueBackgroundColor,'color':'black','padding-top':'7px','padding-bottom':'7px'}"
                        style="width: 100%;color: black;margin-top: 25px;font-size: 12px">
                    <el-table-column v-if="previewLabel.isShowProduceCode===1"
                                     prop="code"
                                     :label=previewLabel.codeLabel
                    >
                    </el-table-column>
                    <el-table-column
                            prop="description"
                            :label=previewLabel.descriptionLabel
                    >
                    </el-table-column>
                    <el-table-column v-if="previewLabel.isShowQuantityAndRate===1"
                                     prop="quantity"
                                     :label=previewLabel.quantityLabel>
                    </el-table-column>

                    <el-table-column
                            prop="rate" :formatter="moneyFormat" v-if="previewLabel.isShowQuantityAndRate===1"
                            :label=previewLabel.rateLabel>
                    </el-table-column>
                    <el-table-column
                            prop="unit" v-if="previewCompanyInfo.isShowItemUnit===1"
                            :label="$t('invoiceDesign.optionUnit')">
                    </el-table-column>
                    <el-table-column
                            prop="tax" v-if="previewLabel.isShowTaxColumn===1"
                            :label=previewLabel.taxLabel>
                    </el-table-column>
                    <el-table-column
                            prop="discount" v-if="previewCompanyInfo.isShowItemDiscount===1"
                            :label=previewLabel.discountLabel>
                    </el-table-column>
                    <el-table-column
                            prop="amount" :formatter="moneyFormat" v-if="previewLabel.isShowAmount===1" :label=previewLabel.amountLabel>
                    </el-table-column>
                </el-table>

                <div style="display: flex;margin-top: 30px;margin-left: 3%;margin-bottom: 50px">
                    <div style="width: 40%;font-size: 12px">
                        <div v-if="previewCompanyInfo.isShowNonTaxableItemStar===1">* {{previewLabel.nonTaxableItemLabel}}</div>
                        <div style="margin-top: 20px">{{$t('invoiceDesign.previewThanksMessage')}}</div>
                    </div>
                    <div style="width: 60%">
                        <div style="display: flex;text-align: right">
                            <div style="width: 60%">
                                <div>{{$t('invoiceDesign.previewSubtotal')}}</div>
                                <div>{{$t('invoiceDesign.previewVat')}}
                                    <span v-if="previewLabel.isShowTaxBreakdown===1">
                                        ({{xiaoshudianfenge1(2195.00000,previewLabel)}})
                                    </span>
                                </div>
                                <div>{{previewLabel.shippingLabel}}</div>
                                <div>{{previewLabel.totalLabel}}</div>
                                <div v-if="previewLabel.isShowPaymentDetail===1">{{$t('invoiceDesign.previewPayment1')}}</div>
                                <div v-if="previewLabel.isShowPaymentDetail===1">{{$t('invoiceDesign.previewPayment2')}}</div>
                                <div>{{previewLabel.paidLabel}}</div>
                                <div v-bind:style="{ 'background-color': itemTableAndBalanceDueBackgroundColor,'color':balanceDueTextColor,'margin-top': '10px','margin-bottom': '10px','font-weight':'bold','padding-top': '10px','padding-bottom': '10px'}">
                                    {{previewLabel.balanceDueLabel}}
                                </div>
                            </div>
                            <div style="width: 40%">
                                <div style="margin-right: 15%">
                                    <div>{{xiaoshudianfenge1(3994.10000,previewLabel)}}</div>
                                    <div>{{xiaoshudianfenge1(373.15000,previewLabel)}}</div>
                                    <div>{{xiaoshudianfenge1(8.00000,previewLabel)}}</div>
                                    <div>{{xiaoshudianfenge1(4375.25000,previewLabel)}}</div>
                                    <div v-if="previewLabel.isShowPaymentDetail===1">{{xiaoshudianfenge1(20.800000,previewLabel)}}</div>
                                    <div v-if="previewLabel.isShowPaymentDetail===1">{{xiaoshudianfenge1(14.800000,previewLabel)}}</div>
                                    <div>{{xiaoshudianfenge1(35.600000,previewLabel)}}</div>
                                </div>
                                <div v-bind:style="{ 'background-color': itemTableAndBalanceDueBackgroundColor,'color':balanceDueTextColor,'margin-top': '10px','margin-bottom': '10px','font-weight':'bold','padding-top': '10px','padding-bottom': '10px','padding-right': '15%'}">
                                    {{xiaoshudianfenge1(4339.65000,previewLabel)}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>


</template>

<script>
    import {timest} from '@/utils/validate'
    import {xiaoshudianfenge} from '@/utils/moneyFormat'
    import {
        replaceStoredCompany,
        replaceStoredSetting,
        syncCompanySelection
    } from '@/utils/company'
    import {getStoredImageDownloadUrl} from '@/utils/fileUpload'
    import {
        MAX_SAFE_NEXT_NUMBER,
        parseNextNumber
    } from '@/utils/invoiceDesignValidation'
    import classicLogo from '@/static/invoice-placeholder-logos/classic.png'
    import impactLogo from '@/static/invoice-placeholder-logos/impact.png'
    import minimalLogo from '@/static/invoice-placeholder-logos/minimal.png'
    import eleganceLogo from '@/static/invoice-placeholder-logos/elegance.png'
    import modernLogo from '@/static/invoice-placeholder-logos/modern.png'
    import creativeLogo from '@/static/invoice-placeholder-logos/creative.png'

    const PLACEHOLDER_LOGOS_BY_STYLE = {
        Classic: classicLogo,
        Impact: impactLogo,
        Minimal: minimalLogo,
        Elegance: eleganceLogo,
        Modern: modernLogo,
        Creative: creativeLogo
    };

    export default {
        computed: {
            previewCompanyInfo() {
                const company = this.companyInfo;
                return {
                    ...company,
                    companyName: this.previewValue(company.companyName, 'Example Company LLC'),
                    contactName: this.previewValue(company.contactName, 'Alex Morgan'),
                    phone: this.previewValue(company.phone, '+1 (206) 555-0123'),
                    companyEmail: this.previewValue(company.companyEmail, 'hello@example.com'),
                    businessNumber: this.previewValue(company.businessNumber, '12345678'),
                    addressOne: this.previewValue(company.addressOne, '123 Market Street'),
                    addressTwo: this.previewValue(company.addressTwo, 'Suite 400'),
                    addressThree: this.previewValue(company.addressThree, 'Seattle, WA 98101'),
                    invoiceNumbering: this.previewValue(company.invoiceNumbering, 'INV-'),
                    logoSize: this.previewValue(company.logoSize, 1),
                    businessNameSize: this.previewValue(company.businessNameSize, 1),
                    hideBusinessName: this.previewValue(company.hideBusinessName, 0),
                    isShowItemUnit: this.previewValue(company.isShowItemUnit, 1),
                    isShowItemDiscount: this.previewValue(company.isShowItemDiscount, 1),
                    isShowNonTaxableItemStar: this.previewValue(company.isShowNonTaxableItemStar, 1)
                };
            },
            previewLabel() {
                const label = this.label;
                return {
                    ...label,
                    invoiceLabel: this.previewValue(label.invoiceLabel, this.$t('invoiceDesign.labelInvoice')),
                    billToLabel: this.previewValue(label.billToLabel, this.$t('invoiceDesign.labelBillTo')),
                    invoiceNoLabel: this.previewValue(label.invoiceNoLabel, this.$t('invoiceDesign.labelInvoiceNo')),
                    dateLabel: this.previewValue(label.dateLabel, this.$t('invoiceDesign.labelDate')),
                    termsLabel: this.previewValue(label.termsLabel, this.$t('invoiceDesign.labelTerms')),
                    termsFormatLabel: this.previewValue(label.termsFormatLabel, 'NET'),
                    term: this.previewValue(label.term, 30),
                    dueDateLabel: this.previewValue(label.dueDateLabel, this.$t('invoiceDesign.labelDueDate')),
                    shipToLabel: this.previewValue(label.shipToLabel, this.$t('invoiceDesign.labelShipTo')),
                    shipDateLabel: this.previewValue(label.shipDateLabel, this.$t('invoiceDesign.labelShipDate')),
                    trackingNoLabel: this.previewValue(label.trackingNoLabel, this.$t('invoiceDesign.labelTrackingNo')),
                    shipViaLabel: this.previewValue(label.shipViaLabel, this.$t('invoiceDesign.labelShipVia')),
                    fobLabel: this.previewValue(label.fobLabel, this.$t('invoiceDesign.labelFob')),
                    taxRegNValue: this.previewValue(label.taxRegNValue, 'VAT: US123456789'),
                    codeLabel: this.previewValue(label.codeLabel, this.$t('invoiceDesign.labelCode')),
                    descriptionLabel: this.previewValue(label.descriptionLabel, this.$t('invoiceDesign.labelDescription')),
                    quantityLabel: this.previewValue(label.quantityLabel, this.$t('invoiceDesign.labelQuantity')),
                    rateLabel: this.previewValue(label.rateLabel, this.$t('invoiceDesign.labelRate')),
                    taxLabel: this.previewValue(label.taxLabel, this.$t('invoiceDesign.labelTax')),
                    discountLabel: this.previewValue(label.discountLabel, this.$t('invoiceDesign.labelDiscount')),
                    amountLabel: this.previewValue(label.amountLabel, this.$t('invoiceDesign.labelAmount')),
                    nonTaxableItemLabel: this.previewValue(label.nonTaxableItemLabel, this.$t('invoiceDesign.labelNonTaxableItem')),
                    shippingLabel: this.previewValue(label.shippingLabel, this.$t('invoiceDesign.labelShipping')),
                    totalLabel: this.previewValue(label.totalLabel, this.$t('invoiceDesign.labelTotal')),
                    paidLabel: this.previewValue(label.paidLabel, this.$t('invoiceDesign.labelPaid')),
                    balanceDueLabel: this.previewValue(label.balanceDueLabel, this.$t('invoiceDesign.labelBalanceDue')),
                    currency: this.previewValue(label.currency, '$'),
                    isShowPaymentTerms: this.previewValue(label.isShowPaymentTerms, 1),
                    isShowDueDate: this.previewValue(label.isShowDueDate, 1),
                    isShowProduceCode: this.previewValue(label.isShowProduceCode, 1),
                    isShowQuantityAndRate: this.previewValue(label.isShowQuantityAndRate, 1),
                    isShowTaxColumn: this.previewValue(label.isShowTaxColumn, 1),
                    isShowAmount: this.previewValue(label.isShowAmount, 1),
                    isShowTaxBreakdown: this.previewValue(label.isShowTaxBreakdown, 1),
                    isShowPaymentDetail: this.previewValue(label.isShowPaymentDetail, 1)
                };
            },
            previewCustomFields() {
                return {
                    other: this.previewValue(this.otherFieldShow, 'www.example.com'),
                    jobLabels: this.previewValue(this.jobdetailShowLeft, this.$t('invoiceDesign.labelFor')),
                    jobValues: this.previewValue(this.jobdetailShowRight, 'Project A')
                };
            },
            logoPreviewSrc() {
                return this.logopath === '' ? PLACEHOLDER_LOGOS_BY_STYLE[this.choosePdfStyle] : this.logopath;
            },
            logoPreviewWidth() {
                return [80, 100, 120][this.previewCompanyInfo.logoSize];
            },
            businessNamePreviewFontSize() {
                return [14, 24][this.previewCompanyInfo.businessNameSize];
            }
        },
        methods: {
            previewValue(value, sample) {
                return value == null || value === '' ? sample : value;
            },
            xiaoshudianfenge1: xiaoshudianfenge,
            designSnapshot() {
                const companyFields = [
                    'invoiceNumbering', 'estimateNumbering', 'purchaseOrderNumbering',
                    'creditMemoNumbering', 'nextNewInvoiceNumber', 'nextNewEstimateNumber',
                    'nextNewPurchaseOrderNumber', 'nextNewCreditMemoNumber', 'isShowPDFPageNumber',
                    'isShowStamp', 'isShowNonTaxableItemStar', 'isShowItemUnit', 'isShowItemDiscount'
                ];
                const settingFields = [
                    'invoiceLabel', 'estimateLabel', 'purchaseOrderLabel', 'creditMemoLabel',
                    'receiptLabel', 'termsFormatLabel', 'billToLabel', 'forLabel', 'dateLabel',
                    'invoiceNoLabel', 'estimateNoLabel', 'purchaseOrderNoLabel', 'creditMemoNoLabel',
                    'dueDateLabel', 'termsLabel', 'amountLabel', 'codeLabel', 'descriptionLabel',
                    'quantityLabel', 'rateLabel', 'taxLabel', 'subtotalLabel', 'balanceDueLabel',
                    'discountLabel', 'nonTaxableItemLabel', 'paidLabel', 'shippingLabel', 'totalLabel',
                    'includesLabel', 'totalAmountPaidLabel', 'shipDateLabel', 'shipToLabel',
                    'shipViaLabel', 'trackingNoLabel', 'fobLabel', 'isShowPaymentTerms',
                    'isShowDueDate', 'isShowShippingField', 'isShowProduceCode',
                    'isShowQuantityAndRate', 'isShowTaxColumn', 'isShowAmount',
                    'isShowTaxBreakdown', 'isShowPaymentDetail'
                ];
                const nextNumberFields = new Set([
                    'nextNewInvoiceNumber', 'nextNewEstimateNumber',
                    'nextNewPurchaseOrderNumber', 'nextNewCreditMemoNumber'
                ]);
                const company = {};
                const setting = {};
                companyFields.forEach(field => {
                    company[field] = nextNumberFields.has(field)
                        ? String(this.companyInfo[field]) : this.companyInfo[field];
                });
                settingFields.forEach(field => {
                    setting[field] = this.label[field];
                });
                return JSON.stringify({
                    company: company,
                    setting: setting,
                    pdfStyle: this.choosePdfStyle,
                    pdfColor: this.chooseColor
                });
            },
            updateDirtyState() {
                this.pageHaveChange = this.initialDesignSnapshot !== ''
                    && this.designSnapshot() !== this.initialDesignSnapshot ? 1 : 0;
            },
            handleChange() {
            },
            moneyFormat: function (row, column) {
                let timestamp = row[column.property];
                let formattedMoney = this.xiaoshudianfenge1(timestamp, this.previewLabel);
                if (column.property === 'amount'
                    && row.isNonTaxable === true
                    && this.previewCompanyInfo.isShowNonTaxableItemStar === 1) {
                    return formattedMoney + '*';
                }
                return formattedMoney;
            },
            validateDesignFields(normalizeNumbers) {
                let nextNumbers;
                try {
                    nextNumbers = [
                        parseNextNumber(this.companyInfo.nextNewInvoiceNumber),
                        parseNextNumber(this.companyInfo.nextNewEstimateNumber),
                        parseNextNumber(this.companyInfo.nextNewPurchaseOrderNumber),
                        parseNextNumber(this.companyInfo.nextNewCreditMemoNumber)
                    ];
                } catch {
                    throw new Error(this.$t('invoiceDesign.invalidNextNumber', {max: MAX_SAFE_NEXT_NUMBER}));
                }
                if (normalizeNumbers) {
                    this.companyInfo.nextNewInvoiceNumber = nextNumbers[0];
                    this.companyInfo.nextNewEstimateNumber = nextNumbers[1];
                    this.companyInfo.nextNewPurchaseOrderNumber = nextNumbers[2];
                    this.companyInfo.nextNewCreditMemoNumber = nextNumbers[3];
                }
            },
            queryUserSetting() {
                this.loading = true;
                this.designLoaded = false;
                this.loadError = '';
                this.buttonDisabledStatus = true;
                let that = this;
                this.$axios.post('query_setting_and_company', {
                    params: {}
                }).then(response => {
                    if (response.data.errorCode !== 0) {
                        throw new Error('Company and setting query failed');
                    }
                    let selectedData = syncCompanySelection(response.data);
                    if (selectedData == null) {
                        throw new Error('Selected company data is missing');
                    }

                        that.label = selectedData.setting;
                        that.choosePdfStyle = that.label.pdfStyle;
                        that.companyInfo = selectedData.company;
                        that.chooseColor = selectedData.company.pdfColor;
                        if (that.chooseColor === '' || that.chooseColor === null) {
                            that.chooseColor = 'rgb(13,125,247)';
                        }
                        if (that.choosePdfStyle === 'Classic' || that.choosePdfStyle === 'Impact') {
                            that.itemTableAndBalanceDueBackgroundColor = that.chooseColor;
                        } else {
                            that.itemTableAndBalanceDueBackgroundColor = 'white';
                        }
                        if (that.choosePdfStyle === 'Modern') {
                            that.modernBackgroundColor = that.chooseColor;
                        } else {
                            that.modernBackgroundColor = "white";
                        }
                        if (that.choosePdfStyle === 'Modern') {
                            that.titlePartColor = "white";
                        } else {
                            that.titlePartColor = 'black';
                        }
                        if (that.choosePdfStyle === 'Classic') {
                            that.balanceDueTextColor = "black";
                        } else if (that.choosePdfStyle === 'Impact') {
                            that.balanceDueTextColor = "white";
                        } else {
                            that.balanceDueTextColor = that.chooseColor;
                        }

                        if (that.choosePdfStyle === 'Creative') {
                            that.creativeInvoiceLabelBackgroundColor = that.chooseColor;
                        } else {
                            that.creativeInvoiceLabelBackgroundColor = 'white';
                        }

                        if (that.choosePdfStyle === 'Modern') {
                            that.invoiceLabelColor = 'white';
                        } else {
                            that.invoiceLabelColor = that.chooseColor;
                        }

                        for (let i = 0; i < that.predefinePdfStyleList.length; i++) {
                            if (that.predefinePdfStyleList[i][0] === that.choosePdfStyle) {
                                that.predefinePdfStyleList[i][1] = "blue";
                            }
                        }

                        that.jobdetailShowLeft = '';
                        that.jobdetailShowRight = '';
                        that.otherFieldShow = '';
                        let jobDetails = that.companyInfo.jobDetails;
                        if (jobDetails != null && jobDetails != '') {
                            let splitSplit = jobDetails.split("&&");
                            for (let i = 0; i < splitSplit.length; i++) {

                                let split1 = splitSplit[i].split(":");
                                if (split1.length < 1) {
                                    continue;
                                }
                                that.jobdetailShowLeft += split1[0] + "</br>";
                                if (split1.length > 1) {
                                    that.jobdetailShowRight += split1[1] + "</br>";
                                }
                            }
                        }

                        let otherFields = that.companyInfo.otherFields;
                        if (otherFields != null && otherFields != '') {
                            let splitArray = otherFields.split("&&");
                            for (let i = 0; i < splitArray.length; i++) {

                                let split1 = splitArray[i].split(":");
                                if (split1.length > 1) {
                                    that.otherFieldShow += split1[1] + "</br>";
                                }
                            }
                        }

                        let companyLogoMap = response.data.companyLogoMap;
                        let companyLogo = companyLogoMap[selectedData.company.innerUUID];
                        if (companyLogo != null) {
                            this.logopath = getStoredImageDownloadUrl(this.$store.state.requestURL, companyLogo);
                            localStorage.setItem('logoPath', companyLogo.imagePath);
                        } else {
                            this.logopath = "";
                            localStorage.setItem('logoPath', "");
                        }
                    this.initialDesignSnapshot = this.designSnapshot();
                    this.pageHaveChange = 0;
                    this.designLoaded = true;
                    this.buttonDisabledStatus = false;
                    this.loading = false;

                    this.$watch('label', function () {
                        this.updateDirtyState();
                    }, {deep: true});
                    this.$watch('companyInfo', function () {
                        this.updateDirtyState();
                    }, {deep: true});
                    this.$watch('choosePdfStyle', this.updateDirtyState);
                    this.$watch('chooseColor', this.updateDirtyState);
                }).catch(() => {
                    this.loading = false;
                    this.loadError = this.$t('common.loadFailed');
                })
            },
            selected: function (color) {
                this.chooseColor = color;
                if (this.choosePdfStyle === 'Classic' || this.choosePdfStyle === 'Impact') {
                    this.itemTableAndBalanceDueBackgroundColor = this.chooseColor;
                } else {
                    this.itemTableAndBalanceDueBackgroundColor = 'white';
                }
                if (this.choosePdfStyle === 'Modern') {
                    this.modernBackgroundColor = this.chooseColor;
                } else {
                    this.modernBackgroundColor = "white";
                }
                if (this.choosePdfStyle === 'Modern') {
                    this.titlePartColor = "white";
                } else {
                    this.titlePartColor = 'black';
                }
                if (this.choosePdfStyle === 'Classic') {
                    this.balanceDueTextColor = "black";
                } else if (this.choosePdfStyle === 'Impact') {
                    this.balanceDueTextColor = "white";
                } else {
                    this.balanceDueTextColor = this.chooseColor;
                }

                if (this.choosePdfStyle === 'Creative') {
                    this.creativeInvoiceLabelBackgroundColor = this.chooseColor;
                } else {
                    this.creativeInvoiceLabelBackgroundColor = 'white';
                }

                if (this.choosePdfStyle === 'Modern') {
                    this.invoiceLabelColor = 'white';
                } else {
                    this.invoiceLabelColor = this.chooseColor;
                }
            },
            selectPdfStyle: function (pdfStyle, index) {
                this.choosePdfStyle = pdfStyle;
                for (let i = 0; i < 6; i++) {
                    this.predefinePdfStyleList[i][1] = "white";
                }
                this.predefinePdfStyleList[index][1] = "blue";

                if (this.choosePdfStyle === 'Classic' || this.choosePdfStyle === 'Impact') {
                    this.itemTableAndBalanceDueBackgroundColor = this.chooseColor;
                } else {
                    this.itemTableAndBalanceDueBackgroundColor = 'white';
                }
                if (this.choosePdfStyle === 'Modern') {
                    this.modernBackgroundColor = this.chooseColor;
                } else {
                    this.modernBackgroundColor = "white";
                }
                if (this.choosePdfStyle === 'Modern') {
                    this.titlePartColor = "white";
                } else {
                    this.titlePartColor = 'black';
                }
                if (this.choosePdfStyle === 'Classic') {
                    this.balanceDueTextColor = "black";
                } else if (this.choosePdfStyle === 'Impact') {
                    this.balanceDueTextColor = "white";
                } else {
                    this.balanceDueTextColor = this.chooseColor;
                }
                if (this.choosePdfStyle === 'Creative') {
                    this.creativeInvoiceLabelBackgroundColor = this.chooseColor;
                } else {
                    this.creativeInvoiceLabelBackgroundColor = 'white';
                }
                if (this.choosePdfStyle === 'Modern') {
                    this.invoiceLabelColor = 'white';
                } else {
                    this.invoiceLabelColor = this.chooseColor;
                }
            },

            saveDesign(flag, next) {
                if (!this.designLoaded || this.loading || this.buttonDisabledStatus || this.pageHaveChange !== 1) {
                    return;
                }
                try {
                    this.validateDesignFields(true);
                } catch (error) {
                    this.$message.error(error.message);
                    return;
                }
                let self = this;
                this.loading = true;

                let companyInfo = {
                    invoiceNumbering: this.companyInfo.invoiceNumbering,
                    estimateNumbering: this.companyInfo.estimateNumbering,
                    purchaseOrderNumbering: this.companyInfo.purchaseOrderNumbering,
                    creditMemoNumbering: this.companyInfo.creditMemoNumbering,
                    nextNewInvoiceNumber: this.companyInfo.nextNewInvoiceNumber,
                    nextNewEstimateNumber: this.companyInfo.nextNewEstimateNumber,
                    nextNewPurchaseOrderNumber: this.companyInfo.nextNewPurchaseOrderNumber,
                    nextNewCreditMemoNumber: this.companyInfo.nextNewCreditMemoNumber,
                    isShowPDFPageNumber: this.companyInfo.isShowPDFPageNumber,
                    isShowStamp: this.companyInfo.isShowStamp,
                    isShowNonTaxableItemStar: this.companyInfo.isShowNonTaxableItemStar,
                    isShowItemUnit: this.companyInfo.isShowItemUnit,
                    isShowItemDiscount: this.companyInfo.isShowItemDiscount,
                    pdfColor: this.chooseColor,

                    accessDate: timest(),
                    innerUUID: this.companyInfo.innerUUID,
                    companyUUID: this.companyInfo.innerUUID
                };

                let settingInfo = {
                    pdfStyle: this.choosePdfStyle,
                    invoiceLabel: this.label.invoiceLabel,
                    estimateLabel: this.label.estimateLabel,
                    purchaseOrderLabel: this.label.purchaseOrderLabel,
                    creditMemoLabel: this.label.creditMemoLabel,
                    termsFormatLabel: this.label.termsFormatLabel,
                    billToLabel: this.label.billToLabel,
                    forLabel: this.label.forLabel,
                    dateLabel: this.label.dateLabel,
                    invoiceNoLabel: this.label.invoiceNoLabel,
                    estimateNoLabel: this.label.estimateNoLabel,
                    creditMemoNoLabel: this.label.creditMemoNoLabel,
                    purchaseOrderNoLabel: this.label.purchaseOrderNoLabel,
                    dueDateLabel: this.label.dueDateLabel,
                    termsLabel: this.label.termsLabel,
                    amountLabel: this.label.amountLabel,
                    codeLabel: this.label.codeLabel,
                    descriptionLabel: this.label.descriptionLabel,
                    quantityLabel: this.label.quantityLabel,
                    rateLabel: this.label.rateLabel,
                    taxLabel: this.label.taxLabel,
                    balanceDueLabel: this.label.balanceDueLabel,
                    discountLabel: this.label.discountLabel,
                    nonTaxableItemLabel: this.label.nonTaxableItemLabel,
                    paidLabel: this.label.paidLabel,
                    shippingLabel: this.label.shippingLabel,
                    totalLabel: this.label.totalLabel,
                    includesLabel: this.label.includesLabel,
                    shipDateLabel: this.label.shipDateLabel,
                    shipToLabel: this.label.shipToLabel,
                    shipViaLabel: this.label.shipViaLabel,
                    trackingNoLabel: this.label.trackingNoLabel,
                    fobLabel: this.label.fobLabel,
                    isShowPaymentTerms: this.label.isShowPaymentTerms,
                    isShowDueDate: this.label.isShowDueDate,
                    isShowShippingField: this.label.isShowShippingField,
                    isShowProduceCode: this.label.isShowProduceCode,
                    isShowTaxColumn: this.label.isShowTaxColumn,
                    isShowAmount: this.label.isShowAmount,
                    isShowTaxBreakdown: this.label.isShowTaxBreakdown,
                    isShowPaymentDetail: this.label.isShowPaymentDetail,
                    isShowQuantityAndRate: this.label.isShowQuantityAndRate,
                    subtotalLabel: this.label.subtotalLabel,
                    receiptLabel: this.label.receiptLabel,
                    totalAmountPaidLabel: this.label.totalAmountPaidLabel,

                    innerUUID: this.label.innerUUID,
                    companyUUID: this.label.companyUUID,
                    accessDate: timest()
                }
                self.buttonDisabledStatus = true;
                this.$axios.post('update_setting_and_company', {
                    params: {"settingReq": settingInfo, "companyReq": companyInfo}
                }).then(response => {
                    this.loading = false;
                    self.buttonDisabledStatus = false;
                    if (response.data.errorCode === 0) {
                        this.initialDesignSnapshot = this.designSnapshot();
                        this.pageHaveChange = 0;

                        let tempUserSetting = JSON.parse(localStorage.getItem('userSetting'));
                        tempUserSetting.pdfStyle = this.choosePdfStyle;
                        tempUserSetting.invoiceLabel = this.label.invoiceLabel;
                        tempUserSetting.estimateLabel = this.label.estimateLabel;
                        tempUserSetting.purchaseOrderLabel = this.label.purchaseOrderLabel;
                        tempUserSetting.creditMemoLabel = this.label.creditMemoLabel;
                        tempUserSetting.termsFormatLabel = this.label.termsFormatLabel;
                        tempUserSetting.billToLabel = this.label.billToLabel;
                        tempUserSetting.forLabel = this.label.forLabel;
                        tempUserSetting.dateLabel = this.label.dateLabel;
                        tempUserSetting.invoiceNoLabel = this.label.invoiceNoLabel;
                        tempUserSetting.estimateNoLabel = this.label.estimateNoLabel;
                        tempUserSetting.creditMemoNoLabel = this.label.creditMemoNoLabel;
                        tempUserSetting.purchaseOrderNoLabel = this.label.purchaseOrderNoLabel;
                        tempUserSetting.dueDateLabel = this.label.dueDateLabel;
                        tempUserSetting.termsLabel = this.label.termsLabel;
                        tempUserSetting.amountLabel = this.label.amountLabel;
                        tempUserSetting.codeLabel = this.label.codeLabel;
                        tempUserSetting.descriptionLabel = this.label.descriptionLabel;
                        tempUserSetting.quantityLabel = this.label.quantityLabel;
                        tempUserSetting.rateLabel = this.label.rateLabel;
                        tempUserSetting.taxLabel = this.label.taxLabel;
                        tempUserSetting.balanceDueLabel = this.label.balanceDueLabel;
                        tempUserSetting.discountLabel = this.label.discountLabel;
                        tempUserSetting.nonTaxableItemLabel = this.label.nonTaxableItemLabel;
                        tempUserSetting.paidLabel = this.label.paidLabel;
                        tempUserSetting.shippingLabel = this.label.shippingLabel;
                        tempUserSetting.totalLabel = this.label.totalLabel;
                        tempUserSetting.includesLabel = this.label.includesLabel;
                        tempUserSetting.shipDateLabel = this.label.shipDateLabel;
                        tempUserSetting.shipToLabel = this.label.shipToLabel;
                        tempUserSetting.shipViaLabel = this.label.shipViaLabel;
                        tempUserSetting.trackingNoLabel = this.label.trackingNoLabel;
                        tempUserSetting.fobLabel = this.label.fobLabel;
                        tempUserSetting.isShowPaymentTerms = this.label.isShowPaymentTerms;
                        tempUserSetting.isShowDueDate = this.label.isShowDueDate;
                        tempUserSetting.isShowShippingField = this.label.isShowShippingField;
                        tempUserSetting.isShowProduceCode = this.label.isShowProduceCode;
                        tempUserSetting.isShowTaxColumn = this.label.isShowTaxColumn;
                        tempUserSetting.isShowAmount = this.label.isShowAmount;
                        tempUserSetting.isShowTaxBreakdown = this.label.isShowTaxBreakdown;
                        tempUserSetting.isShowPaymentDetail = this.label.isShowPaymentDetail;
                        tempUserSetting.isShowQuantityAndRate = this.label.isShowQuantityAndRate;
                        tempUserSetting.subtotalLabel = this.label.subtotalLabel;
                        tempUserSetting.receiptLabel = this.label.receiptLabel;
                        tempUserSetting.totalAmountPaidLabel = this.label.totalAmountPaidLabel;
                        replaceStoredSetting(tempUserSetting);

                        let tempCompany = JSON.parse(localStorage.getItem('userCompany'));
                        tempCompany.invoiceNumbering = this.companyInfo.invoiceNumbering;
                        tempCompany.estimateNumbering = this.companyInfo.estimateNumbering;
                        tempCompany.purchaseOrderNumbering = this.companyInfo.purchaseOrderNumbering;
                        tempCompany.creditMemoNumbering = this.companyInfo.creditMemoNumbering;
                        tempCompany.nextNewInvoiceNumber = this.companyInfo.nextNewInvoiceNumber;
                        tempCompany.nextNewEstimateNumber = this.companyInfo.nextNewEstimateNumber;
                        tempCompany.nextNewPurchaseOrderNumber = this.companyInfo.nextNewPurchaseOrderNumber;
                        tempCompany.nextNewCreditMemoNumber = this.companyInfo.nextNewCreditMemoNumber;
                        tempCompany.isShowPDFPageNumber = this.companyInfo.isShowPDFPageNumber;
                        tempCompany.isShowStamp = this.companyInfo.isShowStamp;
                        tempCompany.isShowNonTaxableItemStar = this.companyInfo.isShowNonTaxableItemStar;
                        tempCompany.isShowItemUnit = this.companyInfo.isShowItemUnit;
                        tempCompany.isShowItemDiscount = this.companyInfo.isShowItemDiscount;
                        tempCompany.pdfColor = this.chooseColor;
                        replaceStoredCompany(tempCompany);

                        this.$message.success({
                            message: this.$t('common.saveSuccess'),
                            center: true
                        });
                        if (flag === 100) {
                            next();
                        }
                    } else {
                        this.$message.error(this.$t('common.saveFailed'));
                    }
                }).catch(function () {
                    self.loading = false;
                    self.buttonDisabledStatus = false;
                    self.$message.error(self.$t('common.systemError'));
                })
            }
        },
        data() {
            return {
                logopath: "",
                chooseColor: '',
                activeNames: "1",
                label: {},
                test11: "1方法",
                companyInfo: {},
                buttonDisabledStatus: true,
                loading: true,
                designLoaded: false,
                loadError: '',
                predefineColors: [
                    'rgb(255,94,139)',
                    'rgb(255,124,158)',
                    'rgb(254,118,200)',
                    'rgb(148,0,211)',
                    'rgb(145,113,237)',
                    'rgb(115,128,248)',
                    'rgb(13,125,247)',
                    'rgb(56,174,233)',
                    'rgb(30,195,146)',
                    'rgb(43,181,104)',
                    'rgb(67,189,54)',
                    'rgb(105,202,25)',
                    'rgb(227,171,19)',
                    'rgb(255,144,89)',
                    'rgb(253,113,109)',
                    'rgb(253,84,79)',
                    'rgb(49,54,5)'
                ],
                predefinePdfStyleList: [
                    ["Classic", "white"],
                    ["Impact", "white"],
                    ["Minimal", "white"],
                    ["Elegance", "white"],
                    ["Modern", "white"],
                    ["Creative", "white"]
                ],
                choosePdfStyle: '',
                itemTableAndBalanceDueBackgroundColor: '',
                modernBackgroundColor: "",
                invoiceLabelColor: "",
                balanceDueTextColor: "",
                creativeInvoiceLabelBackgroundColor: "",
                tableData: [
                    {
                        code: 1001,
                        description: this.$t('classicPDF.previewItem1'),
                        quantity: 1,
                        rate: 1999,
                        unit: "Hour",
                        tax: "0%",
                        discount: "10%",
                        amount: 1799.10,
                        isNonTaxable: true
                    },
                    {
                        code: 1002,
                        description: this.$t('classicPDF.previewItem2'),
                        quantity: 2,
                        rate: 499,
                        unit: "Each",
                        tax: "17%",
                        discount: "0%",
                        amount: 998,
                        isNonTaxable: false
                    },
                    {
                        code: 1003,
                        description: this.$t('classicPDF.previewItem3'),
                        quantity: 3,
                        rate: 399,
                        unit: "Each",
                        tax: "17%",
                        discount: "0%",
                        amount: 1197,
                        isNonTaxable: false
                    },
                ],
                pageHaveChange: 0,
                initialDesignSnapshot: '',
                jobdetailShowLeft: '',
                jobdetailShowRight: '',
                otherFieldShow: ''
            }
        },
        mounted() {
            this.queryUserSetting();
        },
        beforeRouteLeave: function (to, from, next) {
            if (this.pageHaveChange === 1) {
                next(false);
                this.$confirm(this.$t('common.unsavedChangesMsg'), this.$t('common.saveChangesTitle'), {
                    confirmButtonText: this.$t('common.confirmSave'),
                    cancelButtonText: this.$t('common.discard'),
                    distinguishCancelAndClose: true,
                    type: 'warning'
                }).then(() => {
                    // 选择确定
                    this.saveDesign(100, next);
                }).catch(function (action) {
                    if (action === 'cancel') {
                        next();
                    }
                });
            } else {
                next();
            }
        }
    }
</script>
<style scoped>
    .invoice-design-initial-loading {
        min-height: 320px;
    }

    .invoice-design-page,
    .invoice-design-layout {
        height: 100%;
        min-width: 0;
    }

    .invoice-design-layout {
        display: flex;
    }

    @font-face {
        font-family: 'OpenSans';
        src: url('../../static/font/RobotoCondensed-Regular.ttf');
    }

    /deep/ .el-card__body {
        padding-left: 20px;
        padding-top: 2px;
    }

    .aaaa {
        padding: 0 24px;
    }

    .aaaa >>> .el-form-item {
        margin-bottom: 16px;
    }

    /deep/ .aaaa .el-input__inner {
        width: 100%;
        margin-left: 0;
        border-style: none none solid none;
        background-color: #ffffff;
        border-radius: 0px;
        line-height: var(--ui-toolbar-height);
        height: var(--ui-toolbar-height);
        font-size: var(--responsive-font-14);
    }

    /deep/ .el-form--label-top .el-form-item__label {
        padding: 0 0 8px;
        line-height: 20px;
        font-size: var(--ui-font-small);
        font-weight: 500;
    }

    /deep/ .aaaa .el-form-item__content {
        line-height: var(--ui-toolbar-height);
    }

    /deep/ .el-collapse-item__header {
        padding-left: 24px;
        font-size: 16px;
        font-weight: 500;
    }

    .next-number-title {
        margin: 8px 0 12px 24px;
        color: #606266;
        font-size: var(--responsive-font-14);
        font-weight: 500;
    }

    /deep/ .el-button--success {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
        height: var(--ui-control-height);
        font-size: 15px;
        font-weight: 600;
        padding: 0 24px;
        margin: 0;

    }

    /deep/ .el-button--success.is-disabled,
    /deep/ .el-button--success.is-disabled:hover,
    /deep/ .el-button--success.is-disabled:focus {
        background-color: #a0cfff;
        border-color: #a0cfff;
        cursor: not-allowed;
    }

    .el-scrollbar {
        border-top-style: none;
        border-right-style: solid;
        border-right-width: 2px;
        border-right-color: #ebeef4;
    }

    .invoice-design-sidebar {
        height: 100vh;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        border-right: 2px solid #ebeef4;
    }

    .invoice-design-save-bar {
        flex: 0 0 auto;
        padding: 24px;
        text-align: left;
        background: #ffffff;
        border-bottom: 1px solid #ebeef4;
    }

    .invoice-design-scroll {
        flex: 1 1 auto;
        min-height: 0;
    }

    .invoice-design-scroll.el-scrollbar {
        border-right: none;
    }

    .invoice-design-preview-scroll {
        display: flex;
        flex: 1 1 auto;
        min-width: 0;
        min-height: 0;
        padding: 24px;
        box-sizing: border-box;
        overflow: auto;
    }

    .rightScrollbar {
        flex: 0 0 auto;
        width: min(210mm, calc((100vh - 48px) * 210 / 297));
        max-width: 100%;
        aspect-ratio: 210 / 297;
        margin: auto;
        padding-bottom: 1px;
        box-sizing: border-box;
        background: #ffffff;
        font-family: OpenSansblod;
        font-size: 12px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    }

    @media (max-width: 640px) {
        .invoice-design-page {
            overflow-y: auto;
        }

        .invoice-design-layout {
            display: block;
            height: auto;
        }

        .invoice-design-sidebar {
            width: 100% !important;
            height: 62vh;
            min-height: 440px;
            border-right: 0;
            border-bottom: 2px solid #ebeef4;
        }

        .invoice-design-save-bar {
            padding: 24px 72px 24px 24px;
        }

        .invoice-design-options-form >>> .el-form-item {
            display: block;
        }

        .invoice-design-options-form >>> .el-form-item__label {
            float: none;
            width: 100% !important;
            line-height: 24px;
        }

        .invoice-design-options-form >>> .el-form-item__content {
            margin-left: 0 !important;
        }

        .invoice-design-preview-scroll {
            width: 100%;
            overflow-x: auto;
            overflow-y: hidden;
        }

    }
</style>

<style>
    .el-button--success {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }

    .el-button--success:focus, .el-button--success:hover {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }

    @media (max-width: 1280px) {
        .leftScrollbar {
            width: 80%;
        }

    }

    @media (min-width: 1281px) and (max-width: 1500px) {
        .leftScrollbar {
            width: 60%;
        }

    }

    @media (min-width: 1501px) {
        .leftScrollbar {
            width: 35%;
        }

    }
</style>
